<global-breadcrumbs
  [dynamicRoute]="{url: '/profile', label: 'profile.routing.profile'}"
></global-breadcrumbs>

<ng-container [ngSwitch]="isSent$ | async">
  <action-status
    *ngSwitchCase="true"
    titleText="profile-card-verification.status.sent"
  />
  <ng-container *ngSwitchDefault>
    <div class="notification" translate="profile-card-verification.status.initial"></div>
    <card-wrapper>
      <form (ngSubmit)="formSubmit()" [formGroup]="verificationForm">
        <div class="form-group">
          <div class="content">
            <h4 class="ident-h4" translate="profile-card-verification.field.upload"></h4>
            <div
              class="ident-text"
              [innerHTML]="'profile-card-verification.description.upload' | translate"
            ></div>
          </div>
          <div class="card-box">
            <div class="card-box__number-row">
              <span class="card-box__number card-box__number--digits">{{ cardNumber$ | async }}</span>
            </div>
          </div>
          <app-form-field
            [isControlTouched]="verificationForm.controls.files.touched"
            [errors]="verificationForm.controls.files.errors"
            [errorTexts]="fieldErrors"
            [submitErrors]="submitErrors.asObservable()"
          >
            <p
              class="ident-text"
              [innerHTML]="'profile-card-verification.description.identification' | translate: { formats: allowedFileTypes }"
            ></p>
            <file-attach
              [ctrl]="verificationForm.controls.files"
              [settings]="fileAttachSettings"
            ></file-attach>
          </app-form-field>
        </div>
        <btn
          [disabled]="isLoading$ | async"
          buttonText="profile-card-verification.label.send-request"
          type="submit"
        ></btn>
      </form>
    </card-wrapper>
  </ng-container>
</ng-container>
